import { render, staticRenderFns } from "./ProgramElement.vue?vue&type=template&id=4e84e010&"
import script from "./ProgramElement.vue?vue&type=script&lang=js&"
export * from "./ProgramElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports